import { API_CONFIG } from "../config/api";

export interface Article {
  id: string;
  title: string;
  metaDescription: string;
  createdAt: string;
  imageUrl: string;
  slug: string;
  tags: string[];
}

export interface ArticleDetail extends Article {
  contentMarkdown: string;
  contentHtml: string;
}

class ApiHelper {
  private baseUrl: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  private async request<T>(endpoint: string): Promise<T> {
    const response = await fetch(`${this.baseUrl}${endpoint}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  async getArticles(): Promise<Article[]> {
    return this.request<Article[]>(API_CONFIG.ENDPOINTS.ARTICLES);
  }

  async getArticleBySlug(slug: string): Promise<ArticleDetail> {
    return this.request<ArticleDetail>(
      API_CONFIG.ENDPOINTS.ARTICLE_BY_SLUG(slug)
    );
  }
}

export const api = new ApiHelper(API_CONFIG.BASE_URL);
